import React from "react";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { CsvEncoding } from "../../lib/config.ts";

interface Props {
  value: CsvEncoding;
  onChange: (value: CsvEncoding) => void;
}

export const CsvEncodingSelect: React.FC<Props> = ({ value, onChange }) => {
  return (
    <FormControl>
      <FormLabel sx={{ fontSize: "0.875rem" }}>CSV エンコーディング</FormLabel>
      <RadioGroup
        row
        value={value}
        onChange={(e) => onChange(e.target.value as CsvEncoding)}
      >
        <FormControlLabel
          value="utf8"
          control={
            <Radio
              size="small"
              sx={{ color: "#00897B", "&.Mui-checked": { color: "#00897B" } }}
            />
          }
          label="UTF-8"
        />
        <FormControlLabel
          value="sjis"
          control={
            <Radio
              size="small"
              sx={{ color: "#00897B", "&.Mui-checked": { color: "#00897B" } }}
            />
          }
          label="SHIFT-JIS"
        />
      </RadioGroup>
    </FormControl>
  );
};
